import React from 'react';

export const KcalDieet = () => {
	return (
		<>
			<h1 className="mt-10">Dr Simeonsi dieedi etapp 2 – 500 kcal dieet</h1>

			<iframe
				className={"md:hidden w-full aspect-[4/3]"}
				src="https://www.youtube.com/embed/r9RAu7AYcs8?feature=emb_logo"
				title="YouTube video player"
				frameBorder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowFullScreen
			/>

			<iframe
				className={"hidden md:block lg:hidden w-full aspect-[4/3]"}
				src="https://www.youtube.com/embed/r9RAu7AYcs8?feature=emb_logo"
				height={"400"}
				title="YouTube video player"
				frameBorder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowFullScreen
			/>

			<iframe
				className={"hidden md:hidden lg:block w-full aspect-[4/3]"}
				src="https://www.youtube.com/embed/r9RAu7AYcs8?feature=emb_logo"
				height={"560"}
				title="YouTube video player"
				frameBorder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowFullScreen
			/>
		</>
	)
}